import React, { useState, useEffect } from 'react';
import Dropdown from '../components/Dropdown';
import Cross from '@material-ui/icons/Close';
import AllCards from '../components/AllCards';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedOptions } from '../redux/actions/DashboardActions';
import {
  food,
  babyThings,
  healthThings,
  household,
  clothes,
  prov,
} from '../redux/constants';
import DashboardMap from '../components/DashboardMap';

import {
  firstFetchMainCards,
  cancelMainCardsListener,
} from '../redux/actions/cardsActions';
function Dashboard() {
  const dispatch = useDispatch();
  const [selection, setSelection] = useState([]);
  const handleClick = (item) => {
    if (!selection.some((current) => current.id === item.id)) {
      setSelection([...selection, item]);
    } else {
      let selectionAfterRemoval = selection;
      selectionAfterRemoval = selectionAfterRemoval.filter(
        (current) => current.id !== item.id
      );
      setSelection([...selectionAfterRemoval]);
    }
  };
  const isItemSelected = (item) => {
    if (selection.find((current) => current.id === item.id)) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    dispatch(firstFetchMainCards());
    return () => {
      dispatch(cancelMainCardsListener());
    };
  }, []);

  useEffect(() => {
    dispatch(setSelectedOptions(selection));
  }, [selection, dispatch]);

  const selectedOptions = useSelector(
    (state) => state.homeReducer.selectedOptions
  );

  return (
    <div className=' m-2 my-6 sm:m-10'>
      <div
        className='sm:flex sm:flex-row  sm:justify-around
      flex flex-col content-center justify-center items-center '
      >
        <div className='sm:self-start self-center'>
          <Dropdown
            title='حدد محافظتك'
            items={prov}
            handleClick={handleClick}
            isItemSelected={isItemSelected}
          />
          <p className='text-center'>حدد المواد</p>
          <Dropdown
            title='مواد غذائية'
            items={food}
            handleClick={handleClick}
            isItemSelected={isItemSelected}
          />
          <Dropdown
            title='اطفال'
            items={babyThings}
            handleClick={handleClick}
            isItemSelected={isItemSelected}
          />
          <Dropdown
            title='مواد صحية'
            items={healthThings}
            handleClick={handleClick}
            isItemSelected={isItemSelected}
          />
          <Dropdown
            title='ملابس'
            items={clothes}
            handleClick={handleClick}
            isItemSelected={isItemSelected}
          />
          <Dropdown
            title='مواد منزلية'
            items={household}
            handleClick={handleClick}
            isItemSelected={isItemSelected}
          />
          <div
            className=' w-64 mx-2 my-4 h-64 flex flex-row items-start flex-wrap  
          overflow-y-auto scrolling-touch scrollbar-thumb border-2 rounded-lg '
          >
            {selectedOptions
              ? selectedOptions.map((item) => (
                  <div
                    key={item.id}
                    className='m-1 px-2 py-1 bg-gray-700 text-white flex
                    justify-between items-center border rounded-lg'
                  >
                    <span onClick={() => handleClick(item)}>
                      <Cross alt='cross' className='w-3' />
                    </span>
                    <span className='ml-4'>{item.value}</span>
                  </div>
                ))
              : null}
          </div>
        </div>
        <div className='flex flex-col sm:self-start  w-2/3 min-width-17rem '>
          <p className='mt-2 text-center hidden sm:inline-block'>
            حدد المحافظة واختار المواد
          </p>
          <div className='mt-6 '>
            <DashboardMap />
          </div>
        </div>
      </div>

      <div className=''>
        <AllCards fromPage={'Dashboard'} />
      </div>
    </div>
  );
}
export default Dashboard;
